const state = {
  competenciasComportamentais: [],
  competenciasTecnicas: [],
  dadosCompetencias: [],
};

const actions = {
  setCompetencias({ commit }, payload) {
    return new Promise((resolve) => {
      switch (payload.tipo) {
        case 'COMPORTAMENTAL':
          commit('SET_COMPETENCIAS_COMPORTAMENTAIS', payload.competencias);
          break;
        case 'TECNICA':
          commit('SET_COMPETENCIAS_TECNICAS', payload.competencias);
          break;
        default:
          break;
      }
      resolve();
    });
  },
};

const getters = {
  getCompetenciasTecnicas: (st) => (payload) => {
    const competencias = st.competenciasTecnicas.filter((c) => c.unidades.length === 0
      || ((c.unidades.some((u) => u.id === payload.unidadeId))
        && c.mapeamento && c.mapeamento.id === payload.mapeamentoId));
    return competencias.sort((a, b) => a.nomeAtual.localeCompare(b.nomeAtual));
  },
};

const mutations = {
  SET_COMPETENCIAS_COMPORTAMENTAIS(st, competencias) {
    st.competenciasComportamentais = competencias;
  },
  SET_COMPETENCIAS_TECNICAS(st, competencias) {
    st.competenciasTecnicas = competencias;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
